<template>
    <div class="title-block__list">
        <!-- Удалить example из data, после интеграции -->
    </div>
    <h1>Типографика</h1>

    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Вы точно хотите удалить документ?</h5>
                    </div>
                    <div class="modal-body">
                        <p class="text-center color-light">Данное действие нельзя отменить</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Сохранить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Добавить новую программу</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label for="program" class="form-label">Название программы</label>
                            <input type="text" name="program" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Добавить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Вы&nbsp;точно хотите удалить пользователя?</h5>
                    </div>
                    <div class="modal-body">
                        <p class="text-center color-light">
                            Данное действие нельзя отменить
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Оставить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Удалить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Добавить новый раздел</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label for="category" class="form-label">Название раздела</label>
                            <input type="text" name="category" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Добавить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Вы&nbsp;точно хотите удалить роль?</h5>
                    </div>
                    <div class="modal-body">
                        <p class="text-center color-light">
                            Данное действие нельзя отменить
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Оставить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Удалить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Редактировать версию</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label for="version" class="form-label">Название версии</label>
                            <input type="text" name="version" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Сохранить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <!-- При интеграции убрать у модалок position-statick и d-block -->
        <div class="modal position-static d-block" tabindex="1">
            <div class="modal-dialog">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 class="modal-title w-100 text-center">Редактировать раздел</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label for="category" class="form-label">Название раздела</label>
                            <input type="text" name="category" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-primary">
                            Сохранить
                        </button>
                        <button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-4">
        <div class="form-label">Хлебные крошки</div>
        <nav aria-label="breadcrumb" class="d-none d-xl-block">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Документы</a></li>
                <li class="breadcrumb-item"><a href="#">Список документов</a></li>
                <li class="breadcrumb-item active" aria-current="page">Добавить новую статью</li>
            </ol>
        </nav>
    </div>
    <div class="mb-4">
        <div class="form-label">Радиокнопки/таб-контролы</div>
        <div class="row g-2">
            <div class="col-12 col-lg-4">
                <label class="radio-tab d-block">
                    <input type="radio" name="tab-radio" checked>
                    <span class="btn btn-radio d-block">
                        Устройство
                    </span>
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <label class="radio-tab d-block">
                    <input type="radio" name="tab-radio">
                    <span class="btn btn-radio d-block">
                        Группа устройств
                    </span>
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <label class="radio-tab d-block">
                    <input type="radio" name="tab-radio">
                    <span class="btn btn-radio d-block">
                        Контент
                    </span>
                </label>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <div class="form-label">Пагинация</div>
        <nav aria-label="Пример навигации по страницам">
            <ul class="pagination">
                <li class="page-item disabled">
                    <a class="page-link page-link_prev">
                        <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 0.5L1 5.5L6 10.5" stroke="currentColor" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                </li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item active"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                    <a class="page-link page-link_next" href="#">
                        <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 0.5L6 5.5L1 10.5" stroke="currentColor" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="mb-4">
        <file-upload-element></file-upload-element>
    </div>
    <div class="mb-4">
        <label class="form-label">Обычный селект</label>
        <select class="form-select" aria-label="Пример выбора по умолчанию">
            <option selected>Откройте это меню выбора</option>
            <option value="1">Один</option>
            <option value="2">Два</option>
            <option value="3">Три</option>
        </select>
    </div>
    <div class="mb-4">
        <div class="form-label">Селект с поиском</div>
        <v-select class="searchable" v-model="example.search"
            :options="['Селект с поиском', 'Выбор 1', 'Выбор 2', 'Выбор 3']" :deselectFromDropdown="false"
            :clearable="false">
            <template #no-options="{ search, searching, loading }">
                <div class="text-not-found">Не найдено</div>
            </template>
        </v-select>
    </div>
    <div class="mb-4">
        <div class="form-label">Селект без поиска, но на vue</div>
        <v-select class="no-searchable" v-model="example.noSearch"
            :options="['Селект без поиска', 'Выбор 1', 'Выбор 2', 'Выбор 3']" :deselectFromDropdown="false"
            :clearable="false" :searchable="false">
        </v-select>
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput1" class="form-label">Текстовый инпут</label>
        <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Placeholder">
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput2" class="form-label">Новый инпут даты</label>
        <!-- Используется вместе с иипортированным методом из js/utilites.js dateFormat -->
        <VueDatePicker v-model="date" locale="ru" :action-row="{ showSelect: false, showCancel: false }"
            :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"
            :format="dateFormat" :teleport="true">
            <template #input-icon>
                <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"
                        d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />
                </svg>
            </template>
        </VueDatePicker>
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput2" class="form-label">Инпут даты</label>
        <input type="date" class="form-control" id="exampleFormControlInput2" placeholder="Placeholder">
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput3" class="form-label">Инпут даты и времени</label>
        <input type="datetime-local" class="form-control" id="exampleFormControlInput3" placeholder="Placeholder">
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput4" class="form-label">Инпут времени</label>
        <input type="time" class="form-control" id="exampleFormControlInput4">
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput5" class="form-label">Инпут продолжительности</label>
        <input type="time" step="1" class="form-control" id="exampleFormControlInput5">
    </div>
    <div class="mb-4">
        <label for="exampleFormControlInput55" class="form-label">Инпут продолжительности (лучше исп. этот вариант, так
            как может быть время AM/PM)</label>
        <input type="text" class="form-control form-control_tl" id="exampleFormControlInput55" placeholder="00:00:00">
    </div>
    <div class="mb-3">
        <label class="form-label">
            Нативный multiple select
        </label>
        <select class="form-select" size="5" multiple aria-label="пример множественного выбора">
            <option selected>Откройте это меню выбора</option>
            <option value="1">Один</option>
            <option value="2">Два</option>
            <option value="3">Три</option>
            <option value="4">Четыре</option>
            <option value="5">Пять</option>
            <option value="6">Шесть</option>
            <option value="7">Семь</option>
            <option value="8">Восемь</option>
            <option value="9">Девять</option>
        </select>
    </div>
    <div class="mb-4">
        <div class="form-label">Textarea</div>
        <textarea name="" id="" cols="30" rows="10" class="form-control" placeholder="Textarea"></textarea>
    </div>
    <div class="mb-4">
        <div class="mb-1 form-label">Чекбокс</div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="">
        </div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" checked>
        </div>
    </div>
    <div class="mb-4">
        <div class="mb-1 form-label">Список чекбоксов</div>
        <div class="form-check-list">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                    Флажок по умолчанию
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked>
                <label class="form-check-label" for="flexCheckChecked">
                    Выбранный флажок
                </label>
            </div>
        </div>
    </div>
    <div class="mb-4">
        <div class="mb-1 form-label">Радиокнопка</div>
        <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
            <label class="form-check-label" for="flexRadioDefault1">
                Радио по умолчанию
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
            <label class="form-check-label" for="flexRadioDefault2">
                Радио выбранное по умолчанию
            </label>
        </div>
    </div>
    <div class="mb-4">
        <label class="form-label">
            Кастомный компонент экспорта
        </label>
        <a class="btn brn-primary-fit" @click="showExportModal">Показать модалку</a>
        <Transition name="fade">
            <ExportModal v-if="exportModal" :filters="filter" />
        </Transition>
        <!-- Описание что должно быть передано в filters, ниже в script части -->
    </div>
    <div class="toggle-container">
        <label style="padding: 0px;" class="form-label">Слайдер</label>
        <label class="switch">
            <input type="checkbox">
            <span class="slider"></span>
        </label>
    </div>
    <div class="mb-2">
        <label class="form-label">
            Кастомный компонент с фильтрами
        </label>
        <filter-component :filters="filter" />
        <!-- Описание что должно быть передано в filters, ниже в script части -->
    </div>
    <div class="mb-4">
        <div class="select-report-device">
            <div class="box-title">
                Список контента
            </div>
            <div class="box">
                <button class="reset-btn box__close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                            fill="currentColor" />
                    </svg>
                </button>
                <div class="box__inner">
                    <div class="search-control">
                        <input type="text" class="search-control__input form-control" placeholder="Поиск">
                        <button class="search-control__input-btn reset-btn"><svg width="21" height="20" viewBox="0 0 21 20"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                                    fill="currentColor"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="devices-list">
                        <div class="devices-item" draggable="true">
                            <div class="devices-item__info">
                                <div class="devices-cell devices-cell_d"></div>
                                <div class="devices-cell devices-cell_p">
                                    <img src="/images/01-content.jpg" alt="Описание превью" class="devices-preview">
                                </div>
                                <div class="devices-cell devices-cell_n">
                                    Название плейлиста плейлист
                                </div>
                                <div class="devices-cell devices-cell_t">
                                    00:30:55
                                </div>
                            </div>
                        </div>
                        <div class="devices-item" draggable="true">
                            <div class="devices-item__info">
                                <div class="devices-cell devices-cell_d"></div>
                                <div class="devices-cell devices-cell_p">
                                    <img src="/images/02-content.jpg" alt="Описание превью" class="devices-preview">
                                </div>
                                <div class="devices-cell devices-cell_n">
                                    Название плейлиста плейлист
                                </div>
                                <div class="devices-cell devices-cell_t">
                                    00:30:55
                                </div>
                            </div>
                        </div>
                        <div class="devices-item" draggable="true">
                            <div class="devices-item__info">
                                <div class="devices-cell devices-cell_d"></div>
                                <div class="devices-cell devices-cell_p">
                                    <img src="/images/03-content.jpg" alt="Описание превью" class="devices-preview">
                                </div>
                                <div class="devices-cell devices-cell_n">
                                    Название плейлиста плейлист
                                </div>
                                <div class="devices-cell devices-cell_t">
                                    00:30:55
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import example from "../../../data/example";
import FileUploadElement from "../../../elements/FileUploadElement";
import ExportModal from "../../../modals/ExportModal.vue";
import { dateFormat } from "../../../utilites";
import { mapState, mapMutations } from "vuex/dist/vuex.cjs.js"; // импортируем mapState для получения значений, и mapMutations для использования методов

export default {
    name: "TypographyComponent",
    components: {
        FileUploadElement, ExportModal
    },
    data: () => {
        return {
            example,

            filter: [
            // Пропс для кастомного фильтра и модалки экспорта.
            // Это массив объектов, где:

            // type - тип инпута
            // Варианты - select - это v-select, date - это input с типом date, time - это input с типом time, interval - это два input с типом time

            // name - Плейсхолдер для инпута

            // model - v-model который будет использоваться в инпуте
            // ВАЖНО - для type: interval, model это объект со свойствами from и to т.к. нужно два v-model, для начала и для конца интервала
            // см.пример

            // options - опции, нужны только для типа select

            // ВАЖНО - фильтр использует Vuex для передачи значений и методов в компонент в котором используется
            // пример подключения Vuex с комментариями можно увидеть в import, computed и methods
				{
					type: 'select',
					name: 'Бренд',
					model: null,
					options: ['Бренд 1', 'Бренд 2', 'Бренд 3']
				},

				{
					type: 'date',
                    name: 'Дата',
					model: null
				},

				{
					type: 'time',
                    name: 'Время',
					model: null
				},

				{
					type: 'interval',
                    name: 'Интервал времени',
					model: { from: null, to: null }
				},
			],
        };
    },

    computed: {
        ...mapState('filterComponent', ['filterState']), // получаем значение filterState из store filterComponent
        ...mapState('logs', ['exportModal'])
    },

    methods: {
        ...mapMutations('filterComponent', ['clearFilterState']), // получаем метод clearFilterState из store filterComponent
        ...mapMutations('logs', ['showExportModal']),

        dateFormat
    },

    mounted() {
        this.clearFilterState(); // этот метод используется для принудительного сброса фильтров в store.
    }
};
</script>
